import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import InlineErrorMessage from '../../../Edit/inlineErrorMessage';
import Input from '../../../../../components/Input';
import Label from '../../../../../components/Label';

import '../../styles.css';

const MenuInputWithTitle = ({ isErrorVisible, inputId, title, ...rest }) => (
  <div styleName="field">
    <Label styleName="menu-field-label" as="label" htmlFor={inputId}>
      <FormattedMessage {...title} />
    </Label>
    <Input
      id={inputId}
      fluid
      {...rest}
    />
    <InlineErrorMessage
      message="Invalid value."
      isVisible={isErrorVisible}
    />
  </div>
);

MenuInputWithTitle.propTypes = {
  inputId: PropTypes.string,
  title: PropTypes.object,
  pattern: PropTypes.string,
  maxLength: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  isErrorVisible: PropTypes.bool,
};

export default MenuInputWithTitle;
